<template>
    <bottom-dialog v-model="e.show" max-width="550px" :dialog="!$vuetify.breakpoint.mobile" v-if="e.show" scrollable>
        <v-card tile elevation="0">
            <v-card-title class="headline align-start flex-column pa-2 primary primarytext--text" style="overflow-y: auto">
                <div class="font-weight-bold fill-width">
                    {{e.title}}
                    <v-btn icon @click="e.show = false" class="float-right"><v-icon class="primary primarytext--text">mdi-close</v-icon></v-btn>
                </div>
            </v-card-title>

            <v-card-text>
                <v-form v-model="addUserFormValid" autocomplete="off">
                    <form-field
                        v-for="field in visibleChildRegisterFields"
                        :key="field.name"
                        :field="field"
                        star v-model="field.value"
                        :probe="false"
                    />

                    <div v-if="foundUser" class="mt-2">
                        <div>{{$translate('Connect with')}} <span class="font-weight-bold">{{foundUser.name}}</span></div>
                    </div>
                    <div v-else-if="searchResult" class="mt-2">
                        <div>{{$translate('Found')}}</div>
                        <div v-for="user in searchResult" :key="user.id">
                            <span class="font-weight-bold">{{user.name}}</span>
                            <v-btn v-if="isConnected(user)" text color="primary" @click="change(user)">{{$translate('Change association to')}} {{user.name.split(' ')[0]}}</v-btn>
                            <v-btn v-else text color="primary" @click="foundUser = user">{{$translate('Pair with')}} {{user.name.split(' ')[0]}}</v-btn>
                        </div>
                        <v-btn text color="primary" @click="stopSearching = true">{{$translate('I want to add new')}}</v-btn>
                    </div>
                    <div v-else-if="enteredOwnPcode">
                        <span class="error--text">{{$translate('You have entered your own social security number')}}</span>
                    </div>

                    <div v-if="(foundUser || !searchResult) && !enteredOwnPcode" class="zoezi-family-booking-rules">
                        <v-expansion-panels v-model="expandedPanel">
                            <v-expansion-panel class="no-elevation" >
                                <v-expansion-panel-header>
                                    <div class="zoezi-activity-section">
                                        <h3>{{$translate('Booking rules for the family member')}}</h3>
                                        <small>{{ $translate("Here, you can change how you and your family member can book and modify each other's accounts") }}</small>
                                    </div>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-checkbox :label="($translate(!foundUser ? 'Manage the account for' : 'Apply to manage the account for') + ' ' + firstname)" v-model="manage" />
                                    <v-checkbox :label="($translate(!foundUser ? 'Book for' : 'Apply to book for') + ' ' + firstname)" v-model="book" />

                                    <v-checkbox :label="($translate('You should always pay for') + ' ' + firstname)" v-model="pay" />

                                    <v-checkbox :label="$translate(allowBookText)" v-model="book_me" />
                                    <v-checkbox :label="$translate(allowManageText)" v-model="manage_me" />
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </div>
                </v-form>
            </v-card-text>

            <v-card-actions v-if="(foundUser || !searchResult) && !enteredOwnPcode">
                <v-spacer/>
                <v-btn v-if="!foundUser" color="primary" @click="addUser" :loading="addUserLoading" :disabled="!addUserFormValid || !(book || manage || book_me || manage_me)">{{$translate('Add')}} {{firstname}}</v-btn>
                <v-btn v-else-if="manage || book" color="primary" @click="changePermission" :loading="changingPermission" :disabled="!addUserFormValid">{{$translate('Send application to')}} {{firstname}}</v-btn>
                <v-btn v-else-if="!manage && !book && (manage_me || book_me)" color="primary" @click="changePermission" :loading="changingPermission" :disabled="!addUserFormValid">{{addText}}</v-btn>
            </v-card-actions>
        </v-card>
    </bottom-dialog>
</template>

<script>
import BottomDialog from '../components/BottomDialog.vue'
import {isValidPersonalCode,isValidMail, normalizePersonalCodeNumber} from '../util.js'
export default {
    name: 'zoezi-add-user-dialog',

    components: {
        BottomDialog
    },

    watch: {
        'e.show'() {
            if (this.e.show) {
                this.childRegisterFields = this.$store.state.settings.fields.filter(field => this.e.booking_fields ? field.child : (field.register || (field.builtIn && field.name == 'personalCodeNumber' && (field.show || field.changeable_by_member)))).map(field => {
                    field = Object.assign({}, field, {value: null, required: this.e.booking_fields ? field.required_child : field.required});
                    return field;
                });

                let mail = this.childRegisterFields.find(x => x.builtIn && x.name == 'mail');
                if (mail) {
                    this.childRegisterFields.splice(this.childRegisterFields.indexOf(mail), 1);
                    this.childRegisterFields.unshift(mail);
                    this.mailField = mail;
                }
                let pn = this.childRegisterFields.find(x => x.builtIn && x.name == 'personalCodeNumber');
                if (pn) {
                    this.childRegisterFields.splice(this.childRegisterFields.indexOf(pn), 1);
                    this.childRegisterFields.unshift(pn);
                    this.pcodeField = pn;
                }

                this.book = this.manage = true;
                this.book_me = this.manage_me = this.pay = false;
                this.searchResult = null;
                this.foundUser = null;
                this.stopSearching = false;
            }
        },
        'mailField.value'() {
            this.searchUser();
        },
        'pcodeField.value'() {
            this.searchUser();
        },
        stopSearching(stop) {
            if (stop) {
                this.foundUser = null;
                this.searchResult = null;
            }
        }
    },

    data: () => ({
        childRegisterFields: [],
        foundUser: null,
        addUserFormValid: false,
        addUserLoading: false,
        book: false,
        manage: false,
        pay: false,
        book_me: false,
        manage_me: false,
        mailField: null,
        pcodeField: null,
        searchResult: null,
        stopSearching: false,
        changingPermission: false,
        matchingFields: [],
        expandedPanel: 0,
    }),

    computed: {
        e() {
            return this.$store.state.addUserDialog;
        },
        firstname() {
            return (this.foundUser ? this.foundUser.name.split(' ')[0] : this.childRegisterFields.find(x => x.builtIn && x.name == 'firstname')?.value) || this.$translate('the person');
        },
        allowBookText() {
            return this.$translate('Allow {0} to book and cancel activities for you').format(this.firstname);
        },
        allowManageText() {
            return this.$translate('Allow {0} to manage your account').format(this.firstname);
        },
        visibleChildRegisterFields() {
            if (this.enteredOwnPcode) {
                return [this.pcodeField];
            }

            if (!this.foundUser && !this.searchResult) {
                return this.childRegisterFields;
            }

            return this.matchingFields;
        },
        addText() {
            if (this.manage_me || this.book_me) {
                let what = this.manage_me ? 'Add {0} as manager' : 'Add {0} as booker';
                return this.$translate(what).format(this.firstname);
            }

            return '';
        },
        enteredOwnPcode() {
            return this.pcodeField && this.pcodeField.value && normalizePersonalCodeNumber(this.pcodeField.value) == this.$store.state.user.personalCodeNumber;
        }
    },

    methods: {
        addUser() {
            let user = {
                xf: {}
            };
            this.childRegisterFields.forEach(f => {
                if (f.builtIn) {
                    user[f.name] = f.value;
                } else {
                    user.xf[f.name] = f.value;
                }
            });

            if (this.e.homesite_id) {
                user.homesite_id = this.e.homesite_id;
            }

            this.addUserLoading = true;
            this.$api.post('/api/memberapi/child/add', user, {book: this.book, manage: this.manage, book_me: this.book_me, manage_me: this.manage_me, pay: this.pay, full: !this.e.booking_fields}).then(response => {
                this.addUserLoading = false;
                response.json().then(data => {
                    if (response.ok) {
                        this.e.callback?.(data);
                        this.e.show = false;
                    } else {
                        let text = this.$translate(data.message);
                        this.$store.commit('showSnackBar', {text});
                    }
                })
            })
        },
        searchUser() {
            if (this.stopSearching) {
                return;
            }

            this.foundUser = null;
            this.searchResult = null;
            this.matchingFields = [];

            let personalCodeNumber = this.pcodeField && isValidPersonalCode(this.pcodeField.value) ? this.pcodeField.value : null;
            let mail = this.mailField && isValidMail(this.mailField.value) ? this.mailField.value : null;
            if (!personalCodeNumber && !mail) {
                return;
            }

            this.$api.get('/api/user/probe', {personalCodeNumber, mail}).then(res => {
                if (res.exists) {
                    this.matchingFields = [];
                    if (personalCodeNumber) {
                        this.matchingFields.push(this.pcodeField);
                    }
                    if (mail) {
                        this.matchingFields.push(this.mailField);
                    }
                    res.users = res.users.filter(user => user.id != this.$store.state.user.id);

                    if (res.users.length == 1 && !mail && !this.isConnected(res.users[0])) {
                        this.foundUser = res.users[0];
                    } else if (res.users.length) {
                        this.searchResult = res.users;
                    }
                }
            })
        },
        changePermission() {
            this.changingPermission = true;
            let data = {id: this.foundUser.id, book_me: this.book_me, manage_me: this.manage_me, book: this.book, manage: this.manage};
            this.$api.post('/api/memberapi/change', data).then(() => {
                this.changingPermission = false;
                this.e.show = false;
            });
        },
        isConnected(user) {
            return !!this.$store.state.user.canManage.find(x => x.id == user.id) || !!this.$store.state.user.canBookFor.find(x => x.id == user.id);
        },
        change(user) {
            this.$store.commit('showChangeUserDialog', {
                user_id: user.id
            })
        }
    }
}
</script>
